// src/components/LanguageSwitcher.tsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import TR from "../assets/flags/tr.png";
import EN from "../assets/flags/en.svg";

const flags = [
  { code: "tr", img: TR },
  { code: "en", img: EN },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState<string>(i18n.language);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("i18nextLng");
    if (savedLanguage && savedLanguage !== currentLang) {
      i18n.changeLanguage(savedLanguage);
      setCurrentLang(savedLanguage);
    }
  }, [i18n, currentLang]);

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem("i18nextLng", code);
    setCurrentLang(code);
  };

  return (
    <div className="flex items-center gap-1">
      {flags.map((flag) => (
        // Dokunma alanı en az ~44px olacak şekilde padding eklendi (görsel
        // bayrak boyutu aynı kalıyor) - Lighthouse'un "tap target" uyarısı için.
        <button
          key={flag.code}
          onClick={() => changeLanguage(flag.code)}
          aria-label={flag.code === "tr" ? "Türkçe" : "English"}
          className="p-3.5 rounded transition"
        >
          <span
            className={`block w-8 h-5 rounded overflow-hidden border ${
              currentLang === flag.code
                ? "border-yellow-600"
                : "border-gray-200 hover:border-yellow-600"
            }`}
          >
            <img
              src={flag.img}
              alt={flag.code}
              className="w-full h-full object-cover"
            />
          </span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;